/**
 * Created by richard on 7/17/14.
 */
var applicationSubcategories = angular.module('applicationSubcategories', ['schoolModel']);
applicationSubcategories.factory('ApplicationSubcategoriesModelFactory', function(AppModelFactory){
    var ApplicationSubcategoriesModel = function(){
        this.endpoint = '/ApplicationSubcategories';
        this.primaryKey = 'subcatID';
    }
    ApplicationSubcategoriesModel.prototype = new AppModelFactory();
    ApplicationSubcategoriesModel.prototype.parent = AppModelFactory.prototype;
    ApplicationSubcategoriesModel.prototype.new = function()
    {
        var applicationSubcat = {subcatID: ''};
        return (this.data.push(applicationSubcat)) - 1;

    }
    return ApplicationSubcategoriesModel;
});


applicationSubcategories.service('ApplicationSubcategoriesModelService', function(ApplicationSubcategoriesModelFactory){
    var applicationSubcategories = new ApplicationSubcategoriesModelFactory();
    return applicationSubcategories;
});


